interface Props {
  count?: number
}

export function FieldsSectionSkeleton({ count = 4 }: Props) {
  return (
    <div className="space-y-2 p-4">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="h-8 animate-pulse rounded-md bg-grey4" />
      ))}
    </div>
  )
}
